import React, {Component, lazy, Suspense} from 'react'
import {Button, Form, Icon, Input, Select, Upload} from 'antd'
import {compose} from 'recompose'
import {get} from 'lodash'
import {streamUrl} from '../../../../variables/index'
import moment from 'moment'
import Auth from '../../../../modules/Authentication'
import InfoTooltip from '../../../../elements/InfoTooltip'
import CenterSpin from '../../../../elements/CenterSpin'

const EditorContAsync = lazy(() => import('../../../../elements/EditorCont'))
const Option = Select.Option

class BulkEmailForm extends Component {
  normFile = e => {
    if (Array.isArray(e)) {
      return e
    }
    return e && e.fileList
  }

  render() {
    const {getFieldDecorator} = this.props.form
    const {email, emails, onChange, onSelect, onKeydown, template} = this.props
    const formItemLayout = {
      labelCol: {
        xs: {span: 24},
        sm: {span: 2},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 21, offset: 1},
      },
    }
    return (
      <Form layout={'horizontal'}>
        <Form.Item
          style={{color: 'rgba(0, 0, 0, 0.65)'}}
          {...formItemLayout}
          label={
            <InfoTooltip
              title={'You need to update contact default email to appear here.'}
              value={'To'}
            />
          }>
          {getFieldDecorator('to', {
            initialValue: get(email, 'to'),
            rules: [{required: true, message: "To Can't be Empty!"}],
          })(
            <Select mode="multiple" placeholder="Select Email">
              {emails.map(f => (
                <Option key={f}>{f}</Option>
              ))}
            </Select>,
          )}
        </Form.Item>
        <Form.Item {...formItemLayout} label={'CC'}>
          {getFieldDecorator('cc', {
            initialValue: get(email, 'cc'),
          })(<Input placeholder={'CC'} />)}
        </Form.Item>
        <Form.Item {...formItemLayout} label={'BCC'}>
          {getFieldDecorator('bcc', {
            initialValue: get(email, 'bcc'),
          })(<Input placeholder={'BCC'} />)}
        </Form.Item>
        <Form.Item {...formItemLayout} label={'From'}>
          {getFieldDecorator('from', {
            initialValue: get(email, 'from'),
            rules: [{required: true, message: "From Can't be Empty!"}],
          })(<Input placeholder={'From'} />)}
        </Form.Item>
        <Form.Item {...formItemLayout} label={'Subject'}>
          {getFieldDecorator('subject', {
            initialValue: get(email, 'subject'),
            rules: [{required: true, message: "Subject Can't be Empty!"}],
          })(<Input placeholder={'Subject'} />)}
        </Form.Item>
        <Form.Item {...formItemLayout} label={'Body'}>
          <Suspense fallback={<CenterSpin />}>
            <EditorContAsync
              value={template}
              change={onChange}
              select={onSelect}
              keydown={onKeydown}
            />
          </Suspense>
        </Form.Item>
        <Form.Item {...formItemLayout} label="Attachments">
          {getFieldDecorator('attachments', {
            valuePropName: 'fileList',
            getValueFromEvent: this.normFile,
          })(
            <Upload
              name="upload"
              action={`${streamUrl}files/single`}
              headers={{authorization: `Bearer ${new Auth().getAccessToken()}`}}
              data={{
                meta: JSON.stringify({
                  folder: `emails/${moment()}`,
                  subFolder: 'temp',
                  timestamp: moment(),
                  category: 'emails',
                }),
              }}
              listType="picture">
              <Button>
                <Icon type="upload" /> Click to upload
              </Button>
            </Upload>,
          )}
        </Form.Item>
      </Form>
    )
  }
}

BulkEmailForm.propTypes = {}
BulkEmailForm.defaultProps = {}

export default compose(Form.create())(BulkEmailForm)
